import { FormField, Text } from 'evergreen-ui';
import React from 'react';
import { UserFormInput } from '../types';
import {ValidatedTextInputField} from "../../../../common";

type ReadonlyProviderInputProps = {
    providerGuid: string;
    providerName: string;
}
export const ReadonlyProviderInput = ({ providerGuid, providerName }: ReadonlyProviderInputProps) => {
    return (
        <FormField label={<span className='text-base font-normal'>Provider</span>}>
            <ValidatedTextInputField<UserFormInput>
                label={""}
                className='ev-overwrite ev-input-hidden'
                width={320}
                inputHeight={40}
                size={500}
                marginTop='-10px'
                name='providerGuid'
                value={providerGuid}
                data-testid='um-readonly-provider-input'
                validationRules={{
                    required: 'This field is required'
                }}
            />
            <Text width={320} height={40} display='inline-block'>{providerName}</Text>
        </FormField>
    );
};
